<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        {{ "control_image_settings" | translate }}
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_alt" | translate }}
                </label>
                <div class="col-xs-12">
                    <input class="form-control" [value]="alt()" (input)="setAlt($any($event.target).value)" />
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_link" | translate }}
                </label>
                <div class="col-xs-12" [class.has-warning]="linkInvalid() && linkTouched()">
                    <input
                        class="form-control"
                        placeholder="https://example.com"
                        [value]="link()"
                        (input)="setLink($any($event.target).value)"
                        (blur)="linkTouched.set(true)"
                    />
                    @if (linkInvalid() && linkTouched()) {
                        <small class="help-block mb-0">
                            {{ "control_errors_invalid_link" | translate }}
                        </small>
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()" />
